import { Ref, ref } from 'vue';
import { getSearch, ListHeaderItem, RequestData } from '@/components/common/list';
import residentAuthApi from '@/api/pm/resident-auth';

const headers: Array<ListHeaderItem> = [
    {
        label: WordList.DeviceDetailDetailUnitName,
        name: 'UnitName'
    }, {
        label: WordList.RDeviceSearchLabelRoomName,
        name: 'RoomName'
    }, {
        label: WordList.ProperAllTextResident,
        name: 'Name'
    }
];

const initFace = () => {
    // list请求借口及请求参数
    const requestData: Ref<RequestData> = ref({
        url: 'v3/web/community/face/getListForOld',
        param: getSearch({
            Build: 'all',
            Room: 'all',
            Key: ''
        })
    });

    // list搜索查询处理
    const updateList = ref(0);
    const saveParamInPath = ref(false);
    const searchList = () => {
        updateList.value += 1;
        saveParamInPath.value = true;
    };

    const totalCount = ref(0);
    const isShowDeleteDialog = ref(false);
    const deleteAll = (formData: {Password: string}) => {
        const params: {PassWd: string;Type: string} = {
            PassWd: hex_md5(formData.Password),
            Type: 'staffOrResidentDeleteAll'
        };
        residentAuthApi.deleteAllFace(params, () => {
            isShowDeleteDialog.value = false;
            updateList.value += 1;
        });
    };

    return {
        requestData,
        updateList,
        saveParamInPath,
        searchList,
        headers,
        deleteAll,
        totalCount,
        isShowDeleteDialog
    };
};
export default initFace;
